<div class="Modal ModalAjudaPrevidencia">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> help_outline </span>
      <p>Ajuda</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()"> close </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      Por que é preciso indicar suas preferências?
    </h1>
    <p class="TxtModal text-start">
      As preferências de conteúdo nos ajudam a personalizar e enviar
      ofertas especiais para você. A proteção de dados pessoais é nossa
      prioridade. Se quiser mais informações sobre como tratamos os seus
      dados, acesse a nossa <a (click)="openDialogPrivacyPolicy()" class="text-underline">Política de Privacidade.</a>
    </p>
  </div>
</div>
